import React from "react";
import useTeamsApi from "./hooks/use-teams-api";

const TeamsContext = React.createContext();
TeamsContext.displayName = "TeamsContext";

const TeamsProvider = (props) => {
    const teamsApi = useTeamsApi();

    return <TeamsContext.Provider value={teamsApi} {...props} />;
};

const useTeams = () => {
    const context = React.useContext(TeamsContext);
    if (context === undefined) {
        throw new Error(`useTeams must be used within a TeamsContext`);
    }
    return context;
};

export { TeamsProvider, useTeams };
